import BlankIconButton from 'components/Buttons/BlankIconButton'

const FilterButton = styled(BlankIconButton).attrs({
  type: 'filter',
  color: '#9b9b9b',
})``

export default FilterButton
